export const buildPathWithSearchParams = (
  pathname: string,
  searchParams: URLSearchParams,
): string => {
  const queryString = searchParams.toString();

  return queryString ? `${pathname}?${queryString}` : pathname;
};

type ReplaceFn = (href: string, options?: { scroll?: boolean }) => void;

/**
 * Same-path App Router `replace` often skips the history update in production
 * builds. Write history first so the address bar updates, then notify Next so
 * `useSearchParams` can stay in sync for later navigations.
 */
export const replaceCurrentUrl = (url: string, replace: ReplaceFn): void => {
  globalThis.window.history.replaceState(
    globalThis.window.history.state,
    "",
    url,
  );
  replace(url, { scroll: false });
};
